import React from 'react';
interface CTAButtonProps {
  text: string;
  className?: string;
}
export const CTAButton = ({
  text,
  className = ''
}: CTAButtonProps) => {
  return <a href="https://www.thermalure.com/products/thermalure-pro" target="_blank" rel="noopener noreferrer" className={`block w-full max-w-md mx-auto bg-green-600 hover:bg-green-700 text-white text-center font-bold py-4 px-6 rounded-lg text-xl md:text-2xl transition-colors duration-200 ${className}`} data-id="element-142">
      {text}
    </a>;
};